<section class="agentic-page-card" *ngIf="products.length">
  <header class="page-card-header">
    <div class="page-title-area">
      <span class="page-type-badge">{{ pageType }}</span>
      <h3>{{ pageTitle }}</h3>
      <a
        class="page-path"
        *ngIf="pageUrl; else pagePathOnly"
        [href]="pageUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        <mat-icon>link</mat-icon>
        <span>{{ pagePath }}</span>
      </a>
      <ng-template #pagePathOnly>
        <span class="page-path">
          <mat-icon>link</mat-icon>
          <span>{{ pagePath }}</span>
        </span>
      </ng-template>
    </div>

    <div class="page-summary">
      <div class="page-progress">
        <span [style.width.%]="progressWidth"></span>
      </div>
      <span class="page-visible-count">
        {{ counts.visibleCount }} of {{ counts.totalCount }}
        {{ visibleSummaryLabel }}
      </span>
      <span class="page-missing-badge">
        {{ counts.missingCount }} {{ missingBadgeLabel }}
      </span>
    </div>
  </header>

  <div class="agentic-product-grid">
    <app-agentic-product-card
      *ngFor="let product of displayedProducts; trackBy: trackByProduct"
      [product]="product"
      [visible]="isVisible(product)"
      [selectedAgentKey]="selectedAgentKey"
      [selectedAgentLabel]="selectedAgentLabel"
      [isPdpPage]="isPdpPage"
    ></app-agentic-product-card>
  </div>

  <p class="page-footnote">{{ footnoteText }}</p>

  <div class="show-more-wrap" *ngIf="hasMoreProducts">
    <button class="show-more-button" type="button" (click)="showMoreProducts()">
      Show more
    </button>
  </div>
</section>
